import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Grid, Row, Col, Label, Table } from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import AccountingActionCreators from 'actions/AccountingActionCreators';
import CustomersAPI from 'utils/CustomersAPIUtils';
import PayoutStore from 'stores/accounting/PayoutStore';
import SessionStore from 'stores/SessionStore';
import USER_ROLES from 'constants/UserRoles';
import { withTranslation } from 'react-i18next';
import PaymentHistory from '../../payment-history';
import JobHistory from '../../job-history';
import PaymentSummary from '../../payment-summary';
import { getSignedUrl, getDocumentsV2, } from '../../../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../../../stores/ToastStore';
import HistoryTable from '../../history-table';
const getStateFromStores = (id) => {
    const payout = PayoutStore.getPayout(id);
    let balance = 0;
    if (payout)
        balance = payout.amount_due;
    return {
        payout,
        balance,
        loading: false,
    };
};
function fetchPayout(id) {
    const user = SessionStore.getUser();
    if (user && user._type === USER_ROLES.CARRIER) {
        AccountingActionCreators.getCarrierPayout(user._id, id);
    }
}
const queryOptions = {
    limit: 1,
    order: {
        field: 'createdAt',
        direction: 'desc',
    },
};
class PayoutDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            loading: true,
        };
    }
    componentDidMount() {
        PayoutStore.register(this.onChange.bind(this));
        fetchPayout(this.props.match.params.id);
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (!this.state.payout && nextState.payout) {
            this.populateFundingData(nextState.payout);
        }
    }
    componentWillUnmount() {
        PayoutStore.unregister(this.onChange);
    }
    async onChange() {
        var _a, _b, _c, _d;
        const { t } = this.props;
        const payoutState = getStateFromStores(this.props.match.params.id);
        const { data: documentPayout, errors: documentErrors } = await getDocumentsV2([payoutState.payout._id], null, queryOptions);
        if (documentErrors) {
            showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                error: documentErrors[0].message,
            }), 'error');
        }
        const key = (_c = (_b = (_a = documentPayout === null || documentPayout === void 0 ? void 0 : documentPayout.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.key;
        if (key) {
            const { data, errors: signedUrlErrors } = await getSignedUrl(key);
            if (signedUrlErrors) {
                showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                    error: signedUrlErrors[0].message,
                }), 'error');
            }
            else {
                const linkToPayout = (_d = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _d === void 0 ? void 0 : _d.signedUrl;
                payoutState.linkToPayout = linkToPayout;
            }
        }
        else {
            payoutState.linkToPayout = undefined;
        }
        this.setState(payoutState);
    }
    populateFundingData(ref) {
        CustomersAPI.getBankAccounts(ref.carrier._id)
            .then((res) => {
            this.setState((prevState) => {
                const payout = Object.assign({}, prevState.payout);
                const response = res.entity.data;
                payout.carrier.bank_accounts = response.external_accounts;
                return {
                    payout,
                };
            });
        })
            .catch((err) => {
            console.log(err.stack || err);
        });
    }
    sendEmail() {
        return (to) => {
            AccountingActionCreators.emailPayout(this.state.payout._id, to);
        };
    }
    savePayment() {
        return (payment) => {
            AccountingActionCreators.recordPaymentForPayout(this.state.payout._id, payment);
        };
    }
    renderDownloadButton() {
        const { t } = this.props;
        if (!this.state.linkToPayout) {
            return '';
        }
        return (React.createElement("div", null,
            React.createElement("a", { href: this.state.linkToPayout, target: "_blank" }, t('DOWNLOAD_PDF'))));
    }
    renderPayout() {
        const payout = this.state.payout;
        const { t } = this.props;
        const className = 'payout row';
        return (React.createElement("div", { className: className },
            React.createElement(Grid, { className: "main-wrapper" },
                React.createElement(Row, null,
                    React.createElement(Col, { md: 4 },
                        React.createElement("h1", null,
                            React.createElement(Label, { bsStyle: "success" }, payout.number)),
                        React.createElement("br", null),
                        React.createElement(Table, null,
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        payout.carrier.name,
                                        " - ",
                                        payout.carrier.phone),
                                    React.createElement("td", null, "\u00A0")),
                                React.createElement("tr", null,
                                    React.createElement("td", null, t('DUE_DATE_WITH_VALUE', {
                                        dueDate: moment(payout.due_date).format('L'),
                                    })),
                                    React.createElement("td", null, t('DATE_CREATED_WITH_VALUE', {
                                        dateCreated: moment(payout.date_created).format('L'),
                                    }))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, t('STATUS_WITH_VALUE', {
                                        status: humanize(payout.status),
                                    })),
                                    React.createElement("td", null, "\u00A0")),
                                React.createElement("tr", null,
                                    React.createElement("td", null, this.renderDownloadButton()),
                                    React.createElement("td", null, "\u00A0"))))),
                    React.createElement(Col, { md: 3, mdOffset: 3 },
                        React.createElement(PaymentSummary, { total: payout.total, paid: payout.total_payments, balance: this.state.balance }))),
                React.createElement("hr", null),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 6 },
                        React.createElement("h3", { className: "my-0 mb-4" }, t('PAYMENTS')),
                        React.createElement(PaymentHistory, { payments: payout.payments })),
                    React.createElement(Col, { md: 6 }, payout.audit && [
                        React.createElement("h3", null, titleize(t('HISTORY'))),
                        React.createElement(HistoryTable, { data: payout.audit || [], type: "Payout" }),
                    ])),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 12 },
                        React.createElement("h3", { className: "my-0 mb-4" }, titleize(t('JOB', { count: 2 }))),
                        React.createElement(JobHistory, { context: "payout", lineItemGroups: payout.lineItemGroups, currency: payout === null || payout === void 0 ? void 0 : payout.currency }))))));
    }
    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return React.createElement("p", { className: "lead" }, titleize(t('LOADING')));
        }
        return this.renderPayout();
    }
}
PayoutDetails.propTypes = {
    match: PropTypes.object.isRequired,
};
export default withTranslation()(PayoutDetails);
